<template>
  <div>
    <h1>Nova Secretaria executiva</h1>
    <b-card>
      <Form @saved="loadData" />
    </b-card>
  </div>
</template>

<script>
import Form from "../Components/Form.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Form },
  computed: {
    ...mapState("secretarias_executivas", ["secretaria_executiva"]),
  },
  methods: {
    ...mapActions("secretarias_executivas", ["ActionNewSecretariaExecutiva"]),
    loadData(id) {
      this.$router.push({
        name: "secretarias_executivas_edit",
        params: { id: id },
      });
    },
  },
  async created() {
    await this.ActionNewSecretariaExecutiva();
  },
};
</script>

<style></style>
